'use client';

import { useCallback } from 'react';
import { useModal } from 'components/shared/Modal';
import AppHandoffModal from './AppHandoffModal';
import { openPulsomicsApp, pulsomicsStudyLink } from './deeplinks';
import styles from './Studies.module.css';

/**
 * The one interactive element in a study card, split out of Studies so the
 * section around it renders on the server.
 *
 * On a phone this hands off to the app, falling back to the store when it is
 * not installed. Desktop has no app to open, so it gets the same QR modal the
 * rest of the site uses for app handoffs rather than a click that does nothing.
 */
const JoinStudyButton = ({ slug, title }: { slug?: string; title: string }) => {
  const ModalClient = useModal();

  const handleJoin = useCallback(() => {
    if (openPulsomicsApp(pulsomicsStudyLink(slug))) return;
    ModalClient.set(
      <AppHandoffModal
        heading="Join this study in the app"
        text="Scan to install it on your phone."
      />,
    );
    ModalClient.show();
  }, [ModalClient, slug]);

  return (
    <button
      type="button"
      className={styles.joinButton}
      onClick={handleJoin}
      aria-label={`Join the ${title} study in the Ultrahuman app`}
    >
      Join study
    </button>
  );
};

export default JoinStudyButton;
